require('es6-promise').polyfill();
require('isomorphic-fetch');
require('whatwg-fetch-timeout');

export const upload = (url, data) => {

    return fetch(url, {
        method: 'POST',
        body: data,
        timeout: 1000 * 60 * 5,
        credentials: 'include'
    })
        .then(function(response) { return response.json() })
        .then(function(json) {
            return json
        }).catch(function(e) {
            return {fetchError: e}
        })

}




// WEBPACK FOOTER //
// ./src/commons/ex.js